@switch (entity.entityType) {
  @case ('Assertion') {
    <cvc-assertion-popover
      [assertionId]="entity.entityId"
      (contentRendered)="contentRendered.emit()"></cvc-assertion-popover>
  }
  @case ('Disease') {
    <cvc-disease-popover [diseaseId]="entity.entityId"></cvc-disease-popover>
  }
  @case ('EvidenceItem') {
    <cvc-evidence-popover
      [evidenceId]="entity.entityId"
      (contentRendered)="contentRendered.emit()"></cvc-evidence-popover>
  }
  @case ('Feature') {
    <cvc-feature-popover [featureId]="entity.entityId"></cvc-feature-popover>
  }
  @case ('MolecularProfile') {
    <cvc-molecular-profile-popover
      [molecularProfileId]="entity.entityId"></cvc-molecular-profile-popover>
  }
  @case ('Phenotype') {
    <cvc-phenotype-popover
      [phenotypeId]="entity.entityId"></cvc-phenotype-popover>
  }
  @case ('Source') {
    <cvc-source-popover [sourceId]="entity.entityId"></cvc-source-popover>
  }
  @case ('Therapy') {
    <cvc-therapy-popover [therapyId]="entity.entityId"></cvc-therapy-popover>
  }
  @case ('Variant') {
    <cvc-variant-popover
      [variantId]="entity.entityId"
      (contentRendered)="contentRendered.emit()"></cvc-variant-popover>
  }
}
